import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, BehaviorSubject } from 'rxjs';

import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root',
})
export class ReleaseNotesService extends ApiService {
  public activeReleaseNote$: BehaviorSubject<any> = new BehaviorSubject<any>(null);

  constructor(public http: HttpClient) {
    super(http);
  }

  public get(): Observable<ReleaseNote[]> {
    return this.http.get<ReleaseNote[]>(this.endpoint(`api`, `releasenotes`));
  }

  public getById(id: string): Observable<ReleaseNote> {
    return this.http.get<ReleaseNote>(this.endpoint(`api`, `releasenotes`, id));
  }

  public post(data: any): Observable<ReleaseNote> {
    return this.http.post<ReleaseNote>(this.endpoint(`api`, `releasenotes`), data);
  }

  public put(id: string, data: any): Observable<ReleaseNote> {
    return this.http.put<ReleaseNote>(this.endpoint(`api`, `releasenotes`, id), data);
  }

  public delete(id: string): Observable<ReleaseNote> {
    return this.http.delete<ReleaseNote>(this.endpoint(`api`, `releasenotes`, id));
  }

  public getLatest(epoch: number): Observable<ReleaseNote[]> {
    return this.http.get<ReleaseNote[]>(this.endpoint(`api`, `releasenotes`, `latest`, epoch));
  }

  public set activeReleaseNote(value: ReleaseNote | null) {
    this.activeReleaseNote$.next(value);
  }

  public get getActiveReleaseNote() {
    return this.activeReleaseNote$.value;
  }
}

export interface ReleaseNote {
  id: string;
  releaseDate: Date;
  publishDate?: Date;
  isPublished: boolean;
  notes: string;
  createdBy?: string;
  createdOn?: Date;
  modifiedBy?: string;
  modifiedOn?: Date;
}
